<template>
    <v-dialog
        width="unset"
        v-bind:value="value"
        v-bind:fullscreen="$vuetify.breakpoint.mobile"
        v-on:input="$emit('input', $event)"
    >
        <v-card tile class="pb-4">
            <v-toolbar dark color="primary">
                <v-btn icon dark v-on:click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Select courier</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="mt-2">
                * Selected courier will be notified
            </v-card-text>
            <div class="d-flex justify-center pa-4" v-if="loading">
                <v-progress-circular indeterminate />
            </div>
            <v-card class="mx-4 py-2" v-else>
                <v-list-item-group v-on:change="onSelect">
                    <v-list-item
                        v-for="item in courierinfos"
                        v-bind:key="item.id"
                        v-bind:disabled="
                            selectedItem && item.id == selectedItem.id
                        "
                    >
                        <v-list-item-content>
                            <v-list-item-title v-text="item.user.name" />
                        </v-list-item-content>
                        <v-list-item-icon>
                            <v-chip
                                small
                                label
                                class="ml-auto"
                                v-bind:color="getChipColor(item.status)"
                                >{{ item.status }}</v-chip
                            >
                        </v-list-item-icon>
                    </v-list-item>
                </v-list-item-group>
            </v-card>
        </v-card>
    </v-dialog>
</template>

<script>
import courierApi from '@/api/courierApi';
import statusUtil from '@/utils/statusUtil';

export default {
    props: {
        // Value of v-dialog. Controls show/hide
        value: {
            type: Boolean,
            required: true
        },
        // The selected courier. Needed to disable item in list
        // Will be set by parent on 'selected' event,
        // to avoid two-way binding
        selectedItem: {
            type: Object
        }
    },
    data() {
        return {
            loading: false,
            courierinfos: []
        };
    },
    watch: {
        async value(isOpening) {
            if (!isOpening) return;
            this.loading = true;
            const response = await courierApi.getCouriers();
            this.courierinfos = response.data.courierinfos;
            this.loading = false;
        }
    },
    methods: {
        onSelect(index) {
            if (null == index) return;
            this.close();
            const courierinfo = this.courierinfos[index];
            this.$emit('selected', courierinfo);
        },
        close() {
            this.$emit('input', false);
        },
        getChipColor(status) {
            return statusUtil.getCourierStatusColor(status);
        }
    }
};
</script>
